<template>
    <div>
        {{ props.message }}
        <ProgressBar
            mode="indeterminate"
            style="height: 6px; margin-top: 0.5rem"
        ></ProgressBar>
    </div>
</template>

<script setup lang="ts">
const props = withDefaults(
    defineProps<{
        message: string;
    }>(),
    {
        message: "Generating, this may take a minute...",
    }
);
</script>
